const initialState = () => ({
  page: 1,
  lead_status: "applied",
  selected_tab: 0,
  display_daterange: "",
  date_range: [],
  signup_display_daterange: "",
  signup_date_range: [],
  initiated_display_daterange: "",
  initiated_date_range: [],
  initaited_by: "",
  city: [], // multi-select (free-text chips)
  executive_type: "",
  executive_name: "",
  lead_executive_name: "",
  product_type: [], // multi-select
  loan_type: [], // multi-select
  // Payable (staff only): "true" -> loans the partner is paid for, "false" ->
  // the rest, "" -> no filtering. See app-js/payable-filter.js.
  payable_loan_flag: "",
  dealer_id: [], // multi-select
  company_name: "",
  // Borrower Company: the borrower's employer, typed free-hand
  employer_name: "",
  // multi-select; only shown (and only meaningful) on the Rejected tab
  rejection_category: [],
  // multi-select; only shown (and only meaningful) on the Doc Verify tab
  document_request_status: [],
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
